module.exports = __webpack_public_path__ + "static/media/inp-error.034d8981.svg";